export function createEmpresa() {
  return {
    EmpresaId: 0,
    Codigo: '',
    Nombre: '',
    ClaveFiscal: '',
    CalleNumero: '',
    ColoniaCodigoPostal: '',
    Ciudad: '',
    Telefono: '',
    ErpId: '',
    ErpConexion: '',
    ErpDbName: '',
    ErpClave: '',
    EsActivo: true,
    Licencia: ''
  };
}
